import { createContext } from "react";

const ThemeContext = createContext({
    selectedTheme: "",
    setSelectedTheme: () => { },
    setBrandConfig: () => {},
    brandConfig: {},
});
export default ThemeContext;